import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { OVERVIEW_TEXT_TYPE_ID } from '../../../mgmt/communities/components/legalAndTexts/constants';

const HomeTextService = ComposedComponent =>
  reduxFetch([
    {
      resource: 'homeText',
      method: 'get',
      request: (tag, language) => ({
        url: apiRoutes.text(tag, OVERVIEW_TEXT_TYPE_ID, language),
        clearValueOnRequest: true,
      }),
    },
  ])(ComposedComponent);

export default HomeTextService;
